import { render, staticRenderFns } from "./PurchaseOffers.vue?vue&type=template&id=57c31881&"
import script from "./PurchaseOffers.vue?vue&type=script&lang=js&"
export * from "./PurchaseOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports